import { useTranslation } from "react-i18next";

import { IDocumentDetailsPage } from ".";
import styled from "styled-components";
import './style.scss';
import { StepsContentGrid } from 'components/common/StepsContentGrid'
import { DateFormat, AmountFormat, UserNameDisplay, BackButton } from "components/common";
import ViewIcon from 'assets/images/ViewIcon.svg';
import { Status } from "components/common";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import ViewDocumentModal from "../ViewDocumentModal";
import { getDocument } from "services/users";

const PageWrapper = styled.div`
position: relative;
`;

export const DocumentDetailsPage: React.FC<IDocumentDetailsPage> = ({ title, documentData, stepsData, bankDetails, summary,
    receiptRef, processing, children, itemComponent, columns }: IDocumentDetailsPage) => {
    const { t } = useTranslation();

    const history = useHistory();

    const [bankDetailsData, setBankDetailsData] = useState<any>(null);
    const [BAMCId, setBAMCId] = useState();
    const [BAMCStatus, setBAMCStatus] = useState("");
    const [BAMCStatusClass, setBAMCStatusClass] = useState("");
    const [BAMCMeta, setBAMCMeta] = useState<any[] | null>(null);
    const [viewBAMC, setViewBAMC] = useState(false);
    const [receiptData, setReceiptData] = useState<any>(null);

    let approvalDate: any = "-";
    switch (documentData?.meta?.state) {
        case "approved":
        case "deposit.portfolio_processed":
        case "withdrawal.portfolio_processed":
        case "change_investment.portfolio_processed":
        case "processed":
            const state = documentData?.states[0];
            if (state) {
                approvalDate = <DateFormat date={state.dt} lang="en" />;
            }
            break;
    }
    useEffect(() => {
        if (documentData?.meta?.receiptRef) {
            setBAMCId(documentData.meta.receiptRef);
            setBAMCStatus(t("uploaded_text"));
            setBAMCStatusClass("green");
        }
        else {
            setBAMCId(undefined);
            setBAMCStatus(t("pending_text"));
            setBAMCStatusClass("blue");
        }
    }, [documentData]);

    useEffect(() => {
        if (bankDetails) {
            setBankDetailsData(bankDetails);
            const meta = bankDetails?.meta;
            setBAMCMeta(meta ? [
                {
                    title: t("bank_name_label"),
                    value: meta.bank_details?.bank_name
                },
                {
                    title: t("branch_number_label"),
                    value: meta.bank_details?.branch_number
                },
                {
                    title: t("account_number_label"),
                    value: meta.bank_details?.account_number
                }
            ] : null);
        }
        else {
            setBankDetailsData(null);
            setBAMCMeta(null);

        }
    }, [bankDetails]);

    useEffect(() => {
        if(receiptRef) {
            getDocument(String(receiptRef)).then((data) => {
                setReceiptData(data);
            })
        }
    }, [receiptRef]);

    const hideAmount = documentData?.meta?.type != "DEPOSIT";
    const state = !documentData?.meta?.type || documentData?.meta?.type == "PERSONAL_INDEX_UPDATE" ? "approved" : documentData?.meta.state

    return (
        <PageWrapper id={"deposit-details-page"}>
            <div className={"container-fluid"}>
                <div className={"row"}>
                    <div>
                        <div className={"d-flex justify-content-between align-items-end"}>
                            <div className={"d-flex"}>
                                <div className={"ms-3"}><BackButton onPress={() => history.goBack()} text={t("back_text")} /></div>
                            </div>
                            <h2 className={"page-title"}>{title}</h2>
                        </div>
                        <div className="backoffice-tab-content">
                            <div className={"tab-table-head-back-office"}>
                                <div className={"status-col"}><span className={"col-title"}>{t("status_tag_plain")}</span></div>
                                <div className={"type-col"}><span className={"col-title"}>{t("type_tag_plain")}</span></div>
                                <div className={"approval-col"}><span className={"col-title"}>{t("approval_date_tag_plain")}</span></div>
                                <div className={"date-col"}><span className={"col-title"}>{t("request_date_tag_plain")}</span></div>
                                {!hideAmount && <div className={"amount-col"}><span className={"col-title"}>{t("amount_tag_plain")}</span></div>}
                                <div className={"request-col"}><span className={"col-title"}>{t("request_tag_plain")}</span></div>
                            </div>
                            <div className={"backoffice-list-items"}>
                                <div className="backoffice-table-item">
                                    <div className={"status-col-val"}>
                                        <div className="mob-label">{t("status_tag_plain")}</div>
                                        <Status status={state} />
                                    </div>
                                    <div className={"type-col-val"}><div className="mob-label">{t("type_tag_plain")}</div><span className={"col-title"}>{documentData && t(documentData.meta.type)}</span></div>
                                    <div className={"approval-col-val"}><div className="mob-label">{t("approval_date_tag_plain")}</div><span className={"col-title"}>{approvalDate}</span></div>
                                    <div className={"date-col-val"}><div className="mob-label">{t("request_date_tag_plain")}</div><span className={"col-title"}>{documentData && <DateFormat date={documentData.dt} lang="en" />}</span></div>
                                    {!hideAmount && <div className={"amount-col-val"}><div className="mob-label">{t("amount_tag_plain")}</div><span className={"col-title"}>{documentData && <AmountFormat amount={documentData.meta.amount} />}</span></div>}
                                    <div className={"request-col-val"}><div className="mob-label">{t("request_tag_plain")}</div><span className="col-title">{documentData && ('#' + documentData.id)}</span></div>
                                </div>
                            </div>
                        </div>
                        {bankDetailsData && <>
                            <div className="deposit-details-sub">{t("bank_details_tag_plain")}</div>
                            <div className="backoffice-tab-content">
                                <div className={"tab-table-head-back-office"}>
                                    <div className={"status-col"}><span className={"col-title"}>{t("bamc_tag_plain")}</span></div>
                                    <div className={"acc-number-col"}><span className={"col-title"}>{t("account_number_label")}</span></div>
                                    <div className={"branch-col"}><span className={"col-title"}>{t("branch_number_tag_plain")}</span></div>
                                    <div className={"bankname-col"}><span className={"col-title"}>{t("bank_name_tag_plain")}</span></div>
                                    <div className={"username-col"}><span className={"col-title"}>{t("account_holder_tag_plain")}</span></div>
                                </div>
                                <div className={"backoffice-list-items"}>
                                    <div className="backoffice-table-item">
                                        <div className={"status-col-val status-col-val-wide"}>
                                            <div className="mob-label">{t("bamc_tag_plain")}</div>
                                            {BAMCId && <button type={"button"} onClick={() => {
                                                setViewBAMC(true);
                                                //@ts-ignore
                                                document.getElementById("view-document-btn").click();
                                            }} className={"action-btn"}><img src={ViewIcon} /></button>
                                            }
                                            <span className={`status ${BAMCStatusClass}`}>{BAMCStatus}</span>
                                        </div>
                                        <div className={"acc-number-col-val"}><div className="mob-label">{t("account_number_label")}</div><span className={"col-title"}>{bankDetailsData?.meta.bank_details?.account_number}</span></div>
                                        <div className={"branch-col-val"}><div className="mob-label">{t("branch_number_tag_plain")}</div><span className={"col-title"}>{bankDetailsData?.meta.bank_details?.branch_number}</span></div>
                                        <div className={"bankname-col-val"}><div className="mob-label">{t("bank_name_tag_plain")}</div><span className={"col-title"}>{bankDetailsData?.meta.bank_details?.bank_name}</span></div>
                                        <div className={"name-col-val"}>
                                            <div className="mob-label">{t("account_holder_tag_plain")}</div>
                                            <UserNameDisplay lastname={documentData?.meta.lastName} firstname={documentData?.meta.firstName} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>}
                        {receiptData && !bankDetailsData && (
                            <>
                                <div className="deposit-details-sub">{t("receipt_details_tag_plain")}</div>
                                <div className="backoffice-tab-content">
                                    <div className={"tab-table-head-back-office"}>
                                        <div className={"status-col"}><span className={"col-title"}>{t("bamc_tag_plain")}</span></div>
                                        <div className={"acc-number-col"}><span className={"col-title"}>#</span></div>
                                        <div className={"branch-col"}><span className={"col-title"}>{t("request_date_tag_plain")}</span></div>
                                        <div className={"username-col"}><span className={"col-title"}>{t("account_holder_tag_plain")}</span></div>
                                    </div>
                                    <div className={"backoffice-list-items"}>
                                        <div className="backoffice-table-item">
                                            <div className={"status-col-val status-col-val-wide"}>
                                                <div className="mob-label">{t("bamc_tag_plain")}</div>
                                                {BAMCId && <button type={"button"} onClick={() => {
                                                    setViewBAMC(true);
                                                    //@ts-ignore
                                                    document.getElementById("view-document-btn").click();
                                                }} className={"action-btn"}><img src={ViewIcon} /></button>
                                                }
                                                <span className={`status ${BAMCStatusClass}`}>{BAMCStatus}</span>
                                            </div>
                                            <div className={"acc-number-col-val"}><div className="mob-label">{t("account_number_label")}</div><span className={"col-title"}>{receiptData?.id}</span></div>
                                            <div className={"branch-col-val"}><div className="mob-label">{t("branch_number_tag_plain")}</div><span className={"col-title"}>{receiptData?.dt && <DateFormat date={receiptData?.dt} lang="en" />}</span></div>
                                            <div className={"name-col-val"}>
                                                <div className="mob-label">{t("account_holder_tag_plain")}</div>
                                                <UserNameDisplay lastname={documentData?.meta.lastName} firstname={documentData?.meta.firstName} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {summary}
                        {documentData && <StepsContentGrid config={columns} data={stepsData} processing={processing} itemComponent={itemComponent} />}
                    </div>
                </div>
            </div>
            {children}
            <ViewDocumentModal documentId={BAMCId} openViewModal={viewBAMC} documentMeta={BAMCMeta} closeModal={() => {
                setViewBAMC(false);
                //@ts-ignore
                document.getElementById("view-document-btn-close").click();
            }} />
        </PageWrapper>
    );
};
